import { ElementRef } from '@angular/core';
import { SessionStorageService } from "ngx-webstorage";
import { BaseComponent } from '../../../shared/base.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from '../../../core/user/user.service';
import { SessionSettingService } from '../../session-setting/session-setting.service';
import { PreferredSessionTime } from '../../../shared/model/preferred-session-time.model';
import moment from "moment";
import { SessionService } from '../../session/session.service';
import { DAYS_OF_THE_WEEK } from '../../../app.constants';
import { SRQCompletedService } from '../../srq-completed/srq-completed.service';
import { SessionDurationSelectionPopupComponent } from '../../../shared/session-duration-selection-popup/session-duration-selection-popup.component';
import { LookingForHelpTopicsService } from '../../looking-for-help-topics/looking-for-help-topics.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "@angular/router";
import * as i4 from "../../looking-for-help-topics/looking-for-help-topics.service";
import * as i5 from "../../../core/user/user.service";
import * as i6 from "../../session-setting/session-setting.service";
import * as i7 from "../../session/session.service";
import * as i8 from "../../srq-completed/srq-completed.service";
import * as i9 from "../../../shared/wellbeing-header/wellbeing-header.component";
import * as i10 from "@angular/common";
import * as i11 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i12 from "../../looking-for-help-topics-selector/looking-for-help-topics-selector.component";
import * as i13 from "../../session/schedule-session/session-language-selector/session-language-selector.component";
import * as i14 from "../../../shared/session-type-card/session-type-card.component";
import * as i15 from "@angular/material/checkbox";
import * as i16 from "../../../shared/coach-card/coach-card.component";
import * as i17 from "@fortawesome/angular-fontawesome";
import * as i18 from "../../../shared/alert/alert-error.component";
import * as i19 from "../../../shared/language/find-language-from-key.pipe";
const _c0 = ["addLanguageModal"];
function MatchWithACoachComponent_div_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 20);
} }
function MatchWithACoachComponent_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
} }
function MatchWithACoachComponent_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "looking-for-help-topics-selector", 22);
    i0.ɵɵlistener("selectedHelpTopicsChange", function MatchWithACoachComponent_div_3_div_7_Template_looking_for_help_topics_selector_selectedHelpTopicsChange_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.onSelectedTopicsChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedHelpTopics", ctx_r11.selectedTopics)("showParagraph", true);
} }
function MatchWithACoachComponent_div_3_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "session-language-selector", 24);
    i0.ɵɵlistener("onLanguagesSelected", function MatchWithACoachComponent_div_3_div_8_Template_session_language_selector_onLanguagesSelected_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.onSelectedSessionLanguagesChanged($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isMatchWithCoaches", true)("selectedLanguages", ctx_r12.selectedLanguages);
} }
function MatchWithACoachComponent_div_3_div_9_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "session-type-card", 31);
    i0.ɵɵlistener("onSessionTypeSelected", function MatchWithACoachComponent_div_3_div_9_div_5_div_1_Template_session_type_card_onSessionTypeSelected_1_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(4); return ctx_r23.selectSessionType($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r22 = ctx.$implicit;
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("sessionType", type_r22)("selectedSessionType", ctx_r21.selectedSessionType)("sessionDurations", ctx_r21.sessionDurationByType[type_r22])("selected", type_r22 === ctx_r21.selectedSessionType)("isMatchWithACoachComponent", true);
} }
function MatchWithACoachComponent_div_3_div_9_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, MatchWithACoachComponent_div_3_div_9_div_5_div_1_Template, 2, 5, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("flex-direction", ctx_r20.isScreenMd ? "row" : "column");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r20.Object.keys(ctx_r20.sessionDurationByType));
} }
function MatchWithACoachComponent_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵelement(3, "h2", 27);
    i0.ɵɵelement(4, "p", 28);
    i0.ɵɵtemplate(5, MatchWithACoachComponent_div_3_div_9_div_5_Template, 2, 3, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r13.sessionDurationByType != null);
} }
function MatchWithACoachComponent_div_3_div_10_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "mat-checkbox", 44);
    i0.ɵɵlistener("change", function MatchWithACoachComponent_div_3_div_10_div_6_Template_mat_checkbox_change_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const day_r26 = restoredCtx.$implicit; const ctx_r27 = i0.ɵɵnextContext(3); return ctx_r27.selectDay(day_r26); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "span", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r26 = ctx.$implicit;
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r25.selectedDays.includes(day_r26));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiTranslate", "sessionSchedule.button.days." + day_r26);
} }
function MatchWithACoachComponent_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵelement(3, "h2", 32);
    i0.ɵɵelement(4, "p", 33);
    i0.ɵɵelementStart(5, "div", 34);
    i0.ɵɵtemplate(6, MatchWithACoachComponent_div_3_div_10_div_6_Template, 5, 2, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 35);
    i0.ɵɵelementStart(8, "div", 36);
    i0.ɵɵelementStart(9, "div", 37);
    i0.ɵɵelementStart(10, "mat-checkbox", 38);
    i0.ɵɵlistener("change", function MatchWithACoachComponent_div_3_div_10_Template_mat_checkbox_change_10_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.selectTimeOfDay("MORNING"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵelement(12, "span", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 37);
    i0.ɵɵelementStart(14, "mat-checkbox", 38);
    i0.ɵɵlistener("change", function MatchWithACoachComponent_div_3_div_10_Template_mat_checkbox_change_14_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.selectTimeOfDay("AFTERNOON"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div");
    i0.ɵɵelement(16, "span", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 36);
    i0.ɵɵelementStart(18, "div", 37);
    i0.ɵɵelementStart(19, "mat-checkbox", 38);
    i0.ɵɵlistener("change", function MatchWithACoachComponent_div_3_div_10_Template_mat_checkbox_change_19_listener() { i0.ɵɵrestoreView(_r30); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.selectTimeOfDay("LATE_AFTERNOON"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 41);
    i0.ɵɵelement(21, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 37);
    i0.ɵɵelementStart(23, "mat-checkbox", 38);
    i0.ɵɵlistener("change", function MatchWithACoachComponent_div_3_div_10_Template_mat_checkbox_change_23_listener() { i0.ɵɵrestoreView(_r30); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.selectTimeOfDay("EVENING"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 41);
    i0.ɵɵelement(25, "span", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r14.daysOfTheWeek);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r14.windowWidth >= 576 ? "align-items-center" : "");
    i0.ɵɵstyleProp("flex-direction", ctx_r14.windowWidth < 576 ? "column" : "row");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r14.selectedTimesOfDay.includes(ctx_r14.MORNING));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r14.selectedTimesOfDay.includes(ctx_r14.AFTERNOON));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("checked", ctx_r14.selectedTimesOfDay.includes(ctx_r14.LATE_AFTERNOON));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r14.selectedTimesOfDay.includes(ctx_r14.EVENING));
} }
function MatchWithACoachComponent_div_3_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 46);
    i0.ɵɵlistener("click", function MatchWithACoachComponent_div_3_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.back(); });
    i0.ɵɵelementEnd();
} }
const _c1 = function (a0) { return { step: a0 }; };
const _c2 = function (a0) { return { width: a0 }; };
function MatchWithACoachComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtemplate(2, MatchWithACoachComponent_div_3_span_2_Template, 1, 0, "span", 10);
    i0.ɵɵtemplate(3, MatchWithACoachComponent_div_3_span_3_Template, 1, 0, "span", 11);
    i0.ɵɵelement(4, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵelement(6, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MatchWithACoachComponent_div_3_div_7_Template, 2, 2, "div", 15);
    i0.ɵɵtemplate(8, MatchWithACoachComponent_div_3_div_8_Template, 2, 2, "div", 16);
    i0.ɵɵtemplate(9, MatchWithACoachComponent_div_3_div_9_Template, 6, 1, "div", 15);
    i0.ɵɵtemplate(10, MatchWithACoachComponent_div_3_div_10_Template, 26, 9, "div", 15);
    i0.ɵɵelementStart(11, "div", 17);
    i0.ɵɵtemplate(12, MatchWithACoachComponent_div_3_button_12_Template, 1, 0, "button", 18);
    i0.ɵɵelementStart(13, "button", 19);
    i0.ɵɵlistener("click", function MatchWithACoachComponent_div_3_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.next(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.step !== 4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.step === 4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(10, _c1, ctx_r0.step));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(12, _c2, ctx_r0.calculateProgressBarWidth()));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.step === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.step === 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.step === 3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.step === 4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.step > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.isDisabled);
} }
function MatchWithACoachComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "h3", 47);
    i0.ɵɵelementStart(2, "div", 48);
    i0.ɵɵelement(3, "span", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 50);
    i0.ɵɵelementStart(5, "div", 51);
    i0.ɵɵelementStart(6, "div", 52);
    i0.ɵɵelementStart(7, "div", 53);
    i0.ɵɵelementStart(8, "div", 54);
    i0.ɵɵelement(9, "img", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 56);
    i0.ɵɵelement(11, "p", 57);
    i0.ɵɵelement(12, "p", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 51);
    i0.ɵɵelementStart(14, "div", 52);
    i0.ɵɵelementStart(15, "div", 53);
    i0.ɵɵelementStart(16, "div", 54);
    i0.ɵɵelement(17, "img", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 56);
    i0.ɵɵelement(19, "p", 60);
    i0.ɵɵelement(20, "p", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 51);
    i0.ɵɵelementStart(22, "div", 52);
    i0.ɵɵelementStart(23, "div", 53);
    i0.ɵɵelementStart(24, "div", 54);
    i0.ɵɵelement(25, "img", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 56);
    i0.ɵɵelement(27, "p", 63);
    i0.ɵɵelement(28, "p", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵclassProp("show", ctx_r1.subStep === 1)("d-none", ctx_r1.subStep !== 1);
    i0.ɵɵadvance(8);
    i0.ɵɵclassProp("show", ctx_r1.subStep === 2)("d-none", ctx_r1.subStep !== 2);
    i0.ɵɵadvance(8);
    i0.ɵɵclassProp("show", ctx_r1.subStep === 3)("d-none", ctx_r1.subStep !== 3);
} }
function MatchWithACoachComponent_div_6_div_6_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "coach-card", 70);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const cs_r42 = i0.ɵɵnextContext().$implicit;
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coach", cs_r42 == null ? null : cs_r42.coach)("coachDetails", ctx_r44.getCoachDetails(cs_r42 == null ? null : cs_r42.coach.id))("coachReasoningList", ctx_r44.getCoachReasoning(cs_r42 == null ? null : cs_r42.coach.id))("earliestAvailableTime", ctx_r44.getEarliestAvailableTime(cs_r42 == null ? null : cs_r42.coach.id))("selectedLanguages", ctx_r44.selectedLanguages)("selectedSessionType", ctx_r44.selectedSessionType)("selectedSessionDuration", ctx_r44.selectedSessionDuration);
} }
function MatchWithACoachComponent_div_6_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MatchWithACoachComponent_div_6_div_6_div_1_ng_container_1_Template, 2, 7, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r43 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r43 < 3);
} }
function MatchWithACoachComponent_div_6_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "coach-card", 71);
    i0.ɵɵlistener("onChatOptionSelected", function MatchWithACoachComponent_div_6_div_6_div_2_Template_coach_card_onChatOptionSelected_1_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(3); return ctx_r46.getChatOption(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedLanguages", ctx_r41.selectedLanguages)("selectedSessionType", ctx_r41.selectedSessionType)("showChatOptionCard", ctx_r41.isAnyChatCoachAvailable);
} }
function MatchWithACoachComponent_div_6_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵtemplate(1, MatchWithACoachComponent_div_6_div_6_div_1_Template, 2, 1, "div", 30);
    i0.ɵɵtemplate(2, MatchWithACoachComponent_div_6_div_6_div_2_Template, 2, 3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r38.availableSessions.coachesSlots);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.isAnyChatCoachAvailable);
} }
function MatchWithACoachComponent_div_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 72);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "a", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 54);
    i0.ɵɵelement(5, "img", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c3 = function (a0) { return { language: a0 }; };
function MatchWithACoachComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "h3", 65);
    i0.ɵɵelementStart(2, "div", 66);
    i0.ɵɵelement(3, "span", 67);
    i0.ɵɵpipe(4, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 68);
    i0.ɵɵtemplate(6, MatchWithACoachComponent_div_6_div_6_Template, 3, 2, "div", 69);
    i0.ɵɵtemplate(7, MatchWithACoachComponent_div_6_div_7_Template, 6, 0, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "sessionChat.paragraph." + ctx_r2.coachHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiTranslate", "sessionChat.paragraph." + ctx_r2.coachText)("translateValues", i0.ɵɵpureFunction1(7, _c3, i0.ɵɵpipeBind1(4, 5, ctx_r2.selectedLanguages.toString())));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.noResult);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.noResult);
} }
function MatchWithACoachComponent_div_8_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "coach-card", 75);
    i0.ɵɵlistener("onChatOptionSelected", function MatchWithACoachComponent_div_8_div_6_Template_coach_card_onChatOptionSelected_1_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.getChatOption(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coach", ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex] == null ? null : ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex].coach)("coachDetails", ctx_r48.getCoachDetails(ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex] == null ? null : ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex].coach.id))("coachReasoningList", ctx_r48.getCoachReasoning(ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex] == null ? null : ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex].coach.id))("earliestAvailableTime", ctx_r48.getEarliestAvailableTime(ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex] == null ? null : ctx_r48.availableSessions.coachesSlots[ctx_r48.coachIndex].coach.id))("selectedLanguages", ctx_r48.selectedLanguages)("selectedSessionType", ctx_r48.selectedSessionType)("selectedSessionDuration", ctx_r48.selectedSessionDuration);
} }
function MatchWithACoachComponent_div_8_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 72);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "a", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 54);
    i0.ɵɵelement(5, "img", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function MatchWithACoachComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "h3", 65);
    i0.ɵɵelementStart(2, "div", 66);
    i0.ɵɵelement(3, "span", 67);
    i0.ɵɵpipe(4, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 68);
    i0.ɵɵtemplate(6, MatchWithACoachComponent_div_8_div_6_Template, 2, 7, "div", 15);
    i0.ɵɵtemplate(7, MatchWithACoachComponent_div_8_div_7_Template, 6, 0, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "sessionChat.paragraph." + ctx_r3.coachHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiTranslate", "sessionChat.paragraph." + ctx_r3.coachText)("translateValues", i0.ɵɵpureFunction1(7, _c3, i0.ɵɵpipeBind1(4, 5, ctx_r3.selectedLanguages.toString())));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r3.noResult && ctx_r3.availableSessions.coachesSlots.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.noResult);
} }
function MatchWithACoachComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelementStart(1, "button", 77);
    i0.ɵɵlistener("click", function MatchWithACoachComponent_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.swipeCoach("LEFT"); });
    i0.ɵɵelement(2, "fa-icon", 78);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 77);
    i0.ɵɵlistener("click", function MatchWithACoachComponent_div_9_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r53); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.swipeCoach("RIGHT"); });
    i0.ɵɵelement(4, "fa-icon", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function MatchWithACoachComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelementStart(1, "coach-card", 80);
    i0.ɵɵlistener("onChatOptionSelected", function MatchWithACoachComponent_div_10_Template_coach_card_onChatOptionSelected_1_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.getChatOption(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coach", ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex] == null ? null : ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex].coach)("coachDetails", ctx_r5.getCoachDetails(ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex] == null ? null : ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex].coach.id))("coachReasoningList", ctx_r5.getCoachReasoning(ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex] == null ? null : ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex].coach.id))("earliestAvailableTime", ctx_r5.getEarliestAvailableTime(ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex] == null ? null : ctx_r5.availableSessions.coachesSlots[ctx_r5.coachIndex].coach.id))("selectedLanguages", ctx_r5.selectedLanguages)("selectedSessionType", ctx_r5.selectedSessionType)("showChatOptionCard", ctx_r5.isAnyChatCoachAvailable);
} }
function MatchWithACoachComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 81);
    i0.ɵɵelement(1, "button", 82);
    i0.ɵɵelementEnd();
} }
function MatchWithACoachComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "fa-icon", 83);
    i0.ɵɵlistener("click", function MatchWithACoachComponent_ng_template_12_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r59); const ctx_r58 = i0.ɵɵnextContext(); return ctx_r58.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 84);
    i0.ɵɵelementStart(3, "div", 85);
    i0.ɵɵelementStart(4, "div", 86);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "h3", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "jhi-alert-error");
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵelement(9, "p", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 89);
    i0.ɵɵelementStart(11, "button", 90);
    i0.ɵɵlistener("click", function MatchWithACoachComponent_ng_template_12_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r59); const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.skip(); });
    i0.ɵɵelement(12, "span", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 92);
    i0.ɵɵlistener("click", function MatchWithACoachComponent_ng_template_12_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r59); const ctx_r61 = i0.ɵɵnextContext(); return ctx_r61.close(); });
    i0.ɵɵelement(14, "span", 93);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
export class MatchWithACoachComponent extends BaseComponent {
    constructor(elementRef, sessionStorage, modalService, router, lookingForHelpTopicsService, activatedRoute, userService, sessionSettingService, sessionService, srqService) {
        super(sessionStorage, modalService);
        this.elementRef = elementRef;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.router = router;
        this.lookingForHelpTopicsService = lookingForHelpTopicsService;
        this.activatedRoute = activatedRoute;
        this.userService = userService;
        this.sessionSettingService = sessionSettingService;
        this.sessionService = sessionService;
        this.srqService = srqService;
        this.selectedLanguages = [];
        this.selectedDays = [];
        this.selectedTimesOfDay = [];
        this.preferredSessionTime = new PreferredSessionTime();
        this.daysOfTheWeek = DAYS_OF_THE_WEEK;
        this.MORNING = "MORNING" /* MORNING */;
        this.AFTERNOON = "AFTERNOON" /* AFTERNOON */;
        this.LATE_AFTERNOON = "LATE_AFTERNOON" /* LATE_AFTERNOON */;
        this.EVENING = "EVENING" /* EVENING */;
        this.selectedTopics = [];
        this.coachIndex = 0;
        this.isDisabled = false;
        this.noResult = false;
        this.isAnyChatCoachAvailable = false;
        this.srqHistory = [];
        this.Object = Object;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#FFFFFF';
        this.selectedTopics = this.lookingForHelpTopicsService.getSavedHelpTopics();
        this.srqService.srqHistory().subscribe((srqs) => {
            this.srqHistory = srqs.body || [];
            this.activatedRoute.params.subscribe((params) => {
                this.step = parseInt(params["step"], 10);
                if ((this.step === 5 || this.step === 6) && ((this.selectedLanguages.length === 0) ||
                    (this.selectedSessionType === null))) {
                    if (this.srqHistory.length === 0)
                        this.router.navigate(['/wellbeing-start']).then();
                    else
                        this.router.navigate(['wellbeing-result']).then();
                }
                else if (this.step === 1 && this.selectedTopics != null && this.selectedTopics.length > 0) {
                    this.router.navigate(['/match-with-a-coach/2']).then();
                }
                this.isNextButtonDisabled();
            });
        });
        this.userService.current().subscribe(u => {
            this.currentUser = u;
            this.isFirstSession = this.currentUser.endedSessionCount === 0;
            this.sessionSettingService.getSessionDurationByUser(this.currentUser.id).subscribe(sessionDurationByType => {
                this.sessionDurationByType = sessionDurationByType.body;
                console.log(this.sessionDurationByType);
            });
        });
        if (this.availableSessions === null || this.availableSessions === undefined) {
            this.request = this.sessionStorage.retrieve('request');
        }
    }
    calculateProgressBarWidth() {
        let percentage = 25 * this.step;
        return percentage + '%';
    }
    onSelectedTopicsChange(selectedTopics) {
        this.selectedTopics = selectedTopics;
        this.lookingForHelpTopicsService.saveHelpTopics(selectedTopics);
    }
    onSelectedSessionLanguagesChanged(selectedLanguages) {
        this.selectedLanguages = selectedLanguages;
        this.isDisabled = this.isLanguageNextButtonDisabled();
    }
    selectSessionType(event) {
        var _a;
        this.selectedSessionDuration = null;
        if (this.selectedSessionType === event)
            this.selectedSessionType = null;
        else
            this.selectedSessionType = event;
        this.isDisabled = this.isTypeNextButtonDisabled();
        if (this.sessionDurationByType && ((_a = this.sessionDurationByType[this.selectedSessionType]) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            this.openSessionDurationSelectionPopup();
        }
    }
    openSessionDurationSelectionPopup() {
        this.selectedSessionDuration = null;
        const modalRef = this.modalService.open(SessionDurationSelectionPopupComponent);
        modalRef.componentInstance.durations = this.sessionDurationByType[this.selectedSessionType];
        modalRef.componentInstance.sessionType = this.selectedSessionType;
        modalRef.result.then(value => {
            if (value) {
                this.selectedSessionDuration = value;
                this.next();
            }
        }).catch();
    }
    selectDay(day) {
        if (this.selectedDays.includes(day)) {
            let index = this.selectedDays.indexOf(day);
            this.selectedDays.splice(index, 1);
        }
        else {
            this.selectedDays.push(day);
        }
    }
    selectTimeOfDay(timeOfDay) {
        if (this.selectedTimesOfDay.includes(timeOfDay)) {
            let index = this.selectedTimesOfDay.indexOf(timeOfDay);
            this.selectedTimesOfDay.splice(index, 1);
        }
        else {
            this.selectedTimesOfDay.push(timeOfDay);
        }
    }
    isNextButtonDisabled() {
        if (this.step === 1)
            this.isDisabled = false;
        else if (this.step === 2)
            this.isDisabled = this.isLanguageNextButtonDisabled();
        else if (this.step === 3)
            this.isDisabled = this.isTypeNextButtonDisabled();
        else if (this.step === 4)
            this.isDisabled = false;
    }
    isLanguageNextButtonDisabled() {
        var _a;
        return ((_a = this.selectedLanguages) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }
    isTypeNextButtonDisabled() {
        return this.selectedSessionType === null || this.selectedSessionType === undefined;
    }
    back() {
        if (this.step === 2 && this.selectedTopics != null && this.selectedTopics.length > 0)
            this.router.navigate(['/wellbeing-result']).then();
        else
            this.router.navigate(['/match-with-a-coach/' + (this.step - 1)]).then();
        this.isNextButtonDisabled();
    }
    close() {
        this.modalService.dismissAll();
    }
    skip() {
        this.close();
        this.router.navigate(['/match-with-a-coach/' + (this.step + 1)]).then();
    }
    next() {
        if (this.step === 2 && this.lookingForHelpTopicsService.hasAnySavedHelpTopics()) {
            this.lookingForHelpTopicsService.submitUserLookingForHelpTopics('MATCH_WITH_COACH').subscribe();
        }
        if (this.step === 2 && this.selectedLanguages.length < 2) {
            this.modalService.open(this.addLanguageModal, { size: 'md', backdrop: 'static' });
        }
        else {
            this.close();
            this.selectedDays.forEach(sd => {
                this.preferredSessionTime[sd] = [];
                this.selectedTimesOfDay.forEach(st => {
                    this.preferredSessionTime[sd].push(st);
                });
            });
            this.processRequest([this.selectedSessionType], true);
            this.router.navigate(['/match-with-a-coach/' + (this.step + 1)]).then();
            this.isNextButtonDisabled();
            if (this.step >= 4) {
                this.coachIndex = 0;
                // looking for available coaches
                this.sessionService.sessionAvailable(this.request, null, null, null).subscribe(r1 => {
                    this.availableSessions = r1;
                    console.log(this.availableSessions);
                    if (this.isFirstSession) {
                        for (let i = 1; i < 4; i++) {
                            setTimeout(() => {
                                this.subStep = i;
                            }, 6000 * (i - 1));
                        }
                        setTimeout(() => {
                            this.router.navigate(['/match-with-a-coach/' + (this.step + 1)]).then();
                        }, 6000 * 3);
                    }
                    else {
                        setTimeout(() => {
                            this.router.navigate(['/match-with-a-coach/' + (this.step + 1)]).then();
                        }, 3000);
                    }
                    if (this.availableSessions != null) {
                        if (this.availableSessions.coachesSlots != null) {
                            let availableCoachCount = this.availableSessions.coachesSlots.filter(cs => cs.earliestAvailableTime != null).length;
                            if (this.selectedSessionType === 'text') {
                                // we found enough Chat coaches
                                if (availableCoachCount > 2) {
                                    this.determineResultTexts("yourCoach", "fantastic");
                                }
                                else if (availableCoachCount > 0) {
                                    // we found limited Chat coaches
                                    this.determineResultTexts("yourCoach", "limitedText");
                                }
                                else {
                                    // couldn't find any Chat coach
                                    this.noResult = true;
                                    this.determineResultTexts("lets", "noCoaches");
                                }
                            }
                            else if (this.selectedSessionType === 'intro_call' || this.selectedSessionType === 'video') {
                                if (availableCoachCount > 2) {
                                    // we found enough available Video/intro_call coaches
                                    this.determineResultTexts("yourCoach", "fantastic");
                                }
                                else if (availableCoachCount > 0) {
                                    // we found enough limited Video coaches
                                    this.determineResultTexts("yourCoach", "limited" + this.selectedSessionType[0].toUpperCase() + this.selectedSessionType.slice(1));
                                }
                                else {
                                    // couldn't find any Video coach
                                    this.determineResultTexts("explore", "oops" + this.selectedSessionType[0].toUpperCase() + this.selectedSessionType.slice(1));
                                }
                                if (this.availableSessions.coachesSlots.length < 3) {
                                    // couldn't find enough available Video coaches, trying to look for Chat coaches
                                    this.processRequest(['text'], false);
                                    this.sessionService.sessionAvailable(this.request, null, null, null).subscribe(r2 => {
                                        this.chatAvailableSessions = r2;
                                        console.log(this.chatAvailableSessions);
                                        if (this.chatAvailableSessions != null) {
                                            if (this.chatAvailableSessions.coachesSlots != null) {
                                                if (this.chatAvailableSessions.coachesSlots.length !== 0) {
                                                    // found some available chat coaches, suggest chat option
                                                    this.isAnyChatCoachAvailable = true;
                                                }
                                                else {
                                                    // couldn't find any available chat coaches
                                                    if (this.availableSessions.coachesSlots.length !== 0) {
                                                        // there were some available Video coaches, let show them, there is no chat option to suggest
                                                    }
                                                    else {
                                                        // there were no available Video coaches, there is no chat option to suggest, Ah that unfortunate! :(
                                                        this.noResult = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            this.router.navigate(['/match-with-a-coach/2']).then();
                                        }
                                    }, () => console.log("Error fetching sessionsAvailable() service"));
                                }
                            }
                            else {
                                console.log("Selected session type error...");
                            }
                        }
                    }
                    else {
                        this.router.navigate(['/match-with-a-coach/2']).then();
                    }
                }, () => console.log("Error fetching sessionsAvailable() service"));
            }
        }
    }
    determineResultTexts(headerText, text) {
        this.coachHeaderText = headerText;
        this.coachText = text;
    }
    processRequest(sessionTypes, includeUnavailableCoaches) {
        var _a;
        this.request = {
            numberOfDays: 14,
            dateTime: moment(),
            userId: (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.id,
            coachId: null,
            languages: this.selectedLanguages,
            preferredSessionTime: this.preferredSessionTime,
            sessionTypes,
            includeUnavailableCoaches,
            duration: this.selectedSessionDuration
        };
        console.log(this.request);
        this.sessionStorage.store('request', this.request);
    }
    getChatOption() {
        this.isAnyChatCoachAvailable = false;
        if (this.chatAvailableSessions && this.chatAvailableSessions.coachesSlots.length) {
            this.availableSessions = this.chatAvailableSessions;
            this.selectedSessionType = 'text';
            this.selectedSessionDuration = null;
            let availableCoachCount = this.availableSessions.coachesSlots.filter(cs => cs.earliestAvailableTime != null).length;
            if (availableCoachCount > 2) {
                this.determineResultTexts("yourCoach", "fantastic");
            }
            else if (availableCoachCount > 0) {
                // we found limited Chat coaches
                this.determineResultTexts("yourCoach", "limitedText");
            }
            else {
                // couldn't find any Chat coach
                this.noResult = true;
                this.determineResultTexts("lets", "noCoaches");
            }
        }
        else {
            this.router.navigate(['/match-with-a-coach/2']).then();
        }
    }
    getCoachDetails(id) {
        return this.availableSessions.coachDetails.find(cd => cd.coachId === id);
    }
    getCoachReasoning(id) {
        return this.availableSessions.coachReasonings.filter(cr => cr.coach.id === id);
    }
    getEarliestAvailableTime(id) {
        let coachesSlots = this.availableSessions.coachesSlots.find(cs => cs.coach.id === id);
        return coachesSlots ? coachesSlots.earliestAvailableTime : "";
    }
    getSessionDuration(type) {
        return this.sessionDurationByType[type];
    }
    swipeCoach(direction) {
        let maxCoachIndex = this.availableSessions.coachesSlots.length - 1;
        if (maxCoachIndex > 2) {
            maxCoachIndex = 2;
        }
        if (direction === 'LEFT') {
            if (this.coachIndex === 0)
                this.coachIndex = maxCoachIndex;
            else
                this.coachIndex--;
        }
        else if (direction === 'RIGHT') {
            if (this.coachIndex === maxCoachIndex)
                this.coachIndex = 0;
            else
                this.coachIndex++;
        }
        else {
            console.log('Swipe direction is not recognized: ' + direction);
        }
        console.log(this.coachIndex);
    }
    onPopState() {
        if (this.step === 5 || this.step === 6) {
            if (this.srqHistory.length === 0)
                this.router.navigate(['/wellbeing-start']).then();
            else
                this.router.navigate(['/match-with-a-coach/4']).then();
        }
        else if (this.step === 2) {
            if (this.srqHistory.length === 0)
                this.router.navigate(['/wellbeing-start']).then();
            else
                this.router.navigate(['/wellbeing-result']).then();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.sessionStorage.clear('availableSessions');
    }
}
MatchWithACoachComponent.ɵfac = function MatchWithACoachComponent_Factory(t) { return new (t || MatchWithACoachComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.LookingForHelpTopicsService), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i5.UserService), i0.ɵɵdirectiveInject(i6.SessionSettingService), i0.ɵɵdirectiveInject(i7.SessionService), i0.ɵɵdirectiveInject(i8.SRQCompletedService)); };
MatchWithACoachComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MatchWithACoachComponent, selectors: [["match-with-a-coach"]], viewQuery: function MatchWithACoachComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addLanguageModal = _t.first);
    } }, hostBindings: function MatchWithACoachComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("popstate", function MatchWithACoachComponent_popstate_HostBindingHandler($event) { return ctx.onPopState($event); }, false, i0.ɵɵresolveWindow);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 7, consts: [[1, "olha-theme"], [1, "container", "bg-2"], ["class", "looking-for-help-container", 4, "ngIf"], [1, "d-none", "d-xl-block"], [1, "d-xl-none"], ["class", "d-flex justify-content-center align-items-center mt-3", 4, "ngIf"], ["class", "text-center mt-3", 4, "ngIf"], ["addLanguageModal", ""], [1, "looking-for-help-container"], [1, "d-flex", "justify-content-between", "align-items-center", 2, "margin", "0 13%"], ["class", "progress-bar-header", "jhiTranslate", "inukaNgApp.wellbeingStart.matching", 4, "ngIf"], ["class", "progress-bar-header", "jhiTranslate", "inukaNgApp.wellbeingStart.almost", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.wellbeingStart.of", 1, "progress-bar-header", 3, "translateValues"], [1, "progress"], ["role", "progressbar", 1, "progress-bar", 2, "width", "25%", 3, "ngStyle"], [4, "ngIf"], ["style", "margin-bottom: 30px", 4, "ngIf"], [1, "d-flex", "justify-content-center", "button-div"], ["class", "btn btn-secondary m-2 button-secondary", "jhiTranslate", "inukaNgApp.wellbeingScan.back", 3, "click", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.wellbeingScan.next", 1, "btn", "btn-primary", "m-2", "button-primary", 3, "disabled", "click"], ["jhiTranslate", "inukaNgApp.wellbeingStart.matching", 1, "progress-bar-header"], ["jhiTranslate", "inukaNgApp.wellbeingStart.almost", 1, "progress-bar-header"], [3, "selectedHelpTopics", "showParagraph", "selectedHelpTopicsChange"], [2, "margin-bottom", "30px"], [3, "isMatchWithCoaches", "selectedLanguages", "onLanguagesSelected"], [1, "d-flex", "justify-content-center"], [1, "d-flex", "justify-content-center", "align-items-center", 2, "flex-direction", "column"], ["jhiTranslate", "sessionTypeSelection.home.selectType", 1, "header"], ["jhiTranslate", "sessionTypeSelection.home.chatRecommended", 1, "text", 2, "max-width", "500px", "text-align", "center"], ["class", "d-flex justify-content-center", 3, "flex-direction", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "sessionType", "selectedSessionType", "sessionDurations", "selected", "isMatchWithACoachComponent", "onSessionTypeSelected"], ["jhiTranslate", "sessionTypeSelection.home.selectWeekDayTime", 1, "header"], ["jhiTranslate", "sessionTypeSelection.home.letUsKnow", 1, "text", 2, "max-width", "500px", "text-align", "center"], [1, "d-flex", "justify-content-between", "align-items-center", "day-selection"], [1, "d-flex", "justify-content-between", "time-of-day-selection"], [2, "flex", "1"], [1, "d-flex", "justify-content-start", "align-items-center", "mb-3"], [1, "mr-2", "mt-2", 3, "checked", "change"], ["jhiTranslate", "sessionSchedule.button.dayTime.MORNING"], ["jhiTranslate", "sessionSchedule.button.dayTime.AFTERNOON"], [1, "d-flex", "justify-content-start", "align-items-top"], ["jhiTranslate", "sessionSchedule.button.dayTime.LATE_AFTERNOON"], ["jhiTranslate", "sessionSchedule.button.dayTime.EVENING"], [1, "check-box", 3, "checked", "change"], [3, "jhiTranslate"], ["jhiTranslate", "inukaNgApp.wellbeingScan.back", 1, "btn", "btn-secondary", "m-2", "button-secondary", 3, "click"], ["jhiTranslate", "inukaNgApp.wellbeingStart.matchingEnd", 1, "match-end"], [1, "d-flex", "flex-column", "justify-content-center", "align-items-center", "loader-div", 2, "height", "100%", "width", "100%"], [1, "loader"], [1, "olha-theme", "card", "light-bulb-card"], [1, "step"], [1, "row", 2, "padding", "20px 16px 10px 16px"], [1, "col-3"], [1, "image-div"], ["src", "../../../../../content/images/cce.png", "alt", "cce.png"], [1, "col-9", "pl-0", "text-left"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.certified", 1, "header-2"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.allTrained", 1, "text-16"], ["src", "../../../../../content/images/winner.png", "alt", "winner.png"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.highly", 1, "header-2"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.average", 1, "text-16"], ["src", "../../../../../content/images/talented.png", "alt", "talented.png"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.effective", 1, "header-2"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.clientsReport", 1, "text-16"], [1, "your-coach", 3, "jhiTranslate"], [1, "d-flex", "flex-column", "justify-content-center", "align-items-center", "your-coach-text"], [2, "max-width", "500px", 3, "jhiTranslate", "translateValues"], [1, "d-flex", "justify-content-center", "align-items-center"], ["class", "d-flex justify-content-center align-items-center", 4, "ngIf"], [3, "coach", "coachDetails", "coachReasoningList", "earliestAvailableTime", "selectedLanguages", "selectedSessionType", "selectedSessionDuration"], [3, "selectedLanguages", "selectedSessionType", "showChatOptionCard", "onChatOptionSelected"], [1, "text-center"], ["routerLink", "/session/schedule-session", "jhiTranslate", "inukaNgApp.wellbeingStart.viewAllCoaches", 1, "btn", "btn-link"], ["src", "../../../../../content/images/focus.svg", "alt", "focus.svg"], [3, "coach", "coachDetails", "coachReasoningList", "earliestAvailableTime", "selectedLanguages", "selectedSessionType", "selectedSessionDuration", "onChatOptionSelected"], [1, "d-flex", "justify-content-center", "align-items-center", "mt-3"], [1, "scroll", 3, "click"], ["icon", "arrow-left", 1, "coach-scroll-arrow"], ["icon", "arrow-right", 1, "coach-scroll-arrow"], [3, "coach", "coachDetails", "coachReasoningList", "earliestAvailableTime", "selectedLanguages", "selectedSessionType", "showChatOptionCard", "onChatOptionSelected"], [1, "text-center", "mt-3"], ["jhiTranslate", "sessionSchedule.button.chooseAnother", "routerLink", "/session/schedule-session", 1, "btn", "btn-link"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [1, "modal-body"], [1, "header"], ["jhiTranslate", "sessionLanguageSelection.elevate", 1, "mb-3"], ["jhiTranslate", "sessionLanguageSelection.addAnother"], [1, "d-flex", "justify-content-end"], ["type", "button", 1, "popup-button", "btn", "btn-popup", "btn-secondary", "justify-content-center", "skip-link", 3, "click"], ["jhiTranslate", "sessionLanguageSelection.skip"], ["type", "button", 1, "popup-button", "btn", "btn-popup", "btn-primary", "btn-primary-popup", "justify-content-center", 3, "click"], ["jhiTranslate", "sessionLanguageSelection.add"]], template: function MatchWithACoachComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "wellbeing-header");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, MatchWithACoachComponent_div_3_Template, 14, 14, "div", 2);
        i0.ɵɵtemplate(4, MatchWithACoachComponent_div_4_Template, 29, 12, "div", 2);
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtemplate(6, MatchWithACoachComponent_div_6_Template, 8, 9, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵtemplate(8, MatchWithACoachComponent_div_8_Template, 8, 9, "div", 2);
        i0.ɵɵtemplate(9, MatchWithACoachComponent_div_9_Template, 5, 0, "div", 5);
        i0.ɵɵtemplate(10, MatchWithACoachComponent_div_10_Template, 2, 7, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, MatchWithACoachComponent_div_11_Template, 2, 0, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, MatchWithACoachComponent_ng_template_12_Template, 15, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.step < 5);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.step === 5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.step === 6);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.step === 6);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.step === 6 && !ctx.noResult && ctx.availableSessions.coachesSlots.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.step === 6 && !ctx.noResult && ctx.isAnyChatCoachAvailable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.step === 6 && !ctx.noResult);
    } }, directives: [i9.WellbeingHeaderComponent, i10.NgIf, i11.JhiTranslateDirective, i10.NgStyle, i12.LookingForHelpTopicsSelectorComponent, i13.SessionLanguageSelectorComponent, i10.NgForOf, i14.SessionTypeCardComponent, i15.MatCheckbox, i16.CoachCardComponent, i3.RouterLinkWithHref, i17.FaIconComponent, i3.RouterLink, i18.AlertErrorComponent], pipes: [i19.FindLanguageFromKeyPipe], styles: [".looking-for-help-container[_ngcontent-%COMP%]{margin-right:auto;margin-left:auto}.container[_ngcontent-%COMP%]{margin:90px 20px 20px !important;width:auto;max-width:1169px !important;padding-top:30px !important;text-align:center;min-height:720px !important;height:auto !important}.progress-bar-header[_ngcontent-%COMP%]{color:var(--fill-green, #44A38B);font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%;text-align:start !important;margin-top:40px}.progress[_ngcontent-%COMP%]{background-color:#e1e1e1;border-radius:5px;width:75%;height:10px;margin:0 auto 40px auto}.progress-bar[_ngcontent-%COMP%]{background-color:var(--main)}.header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);text-align:center;font-family:Poppins,serif;font-size:18px;font-style:normal;font-weight:600;line-height:130%}.header-2[_ngcontent-%COMP%]{color:#0a4a3a;font-family:Poppins,serif;font-size:16px;font-style:normal;font-weight:600;line-height:130%}.text[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);text-align:center;font-feature-settings:\"clig\" off,\"liga\" off;font-family:Open Sans,serif;font-size:12px;font-style:normal;font-weight:400;line-height:140%}.choose-text[_ngcontent-%COMP%]{display:block;margin:20px auto;width:300px;text-align:center;font-size:.75rem}.type-selection-card[_ngcontent-%COMP%]{width:100% !important;border-radius:20px;padding:25px 20px;margin:20px}.button-primary[_ngcontent-%COMP%]{width:130px;height:40px;flex-shrink:0;display:flex;padding:14px 4px;justify-content:center;align-items:center;gap:10px;border-radius:60px}.button-secondary[_ngcontent-%COMP%]{display:flex;width:130px;height:40px;padding:14px 4px;justify-content:center;align-items:center;gap:10px;flex-shrink:0;border-radius:60px;border:1px solid var(--Fill-Green, #44A38B);background:var(--Fill-Background---White, #FFF)}.day-selection[_ngcontent-%COMP%], .time-of-day-selection[_ngcontent-%COMP%]{width:288px;margin-top:20px}.button-div[_ngcontent-%COMP%]{margin-top:20px}.match-end[_ngcontent-%COMP%]{margin:100px auto 30px auto}.your-coach[_ngcontent-%COMP%]{margin:30px auto 5px auto}.your-coach-text[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);text-align:center;font-feature-settings:\"clig\" off,\"liga\" off;font-family:Open Sans,serif;font-size:12px;font-style:normal;font-weight:400;line-height:140%;margin-bottom:20px;height:100%;width:100%}.loader-div[_ngcontent-%COMP%]{margin:0 auto 86px auto}.light-bulb-card[_ngcontent-%COMP%]{margin:auto;border-radius:10px !important}.light-bulb-image[_ngcontent-%COMP%]{width:40px !important;height:40px !important}.image-div[_ngcontent-%COMP%]{width:70px !important;height:70px !important}.light-bulb-header[_ngcontent-%COMP%]{color:var(--Dark-Text, #0A4A3A);font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%}.light-bulb-text[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-feature-settings:\"clig\" off,\"liga\" off;font-family:Open Sans,serif;font-size:12px;font-style:normal;font-weight:400;line-height:140%}.main-body[_ngcontent-%COMP%]{padding:30px 30px 20px 30px}.close[_ngcontent-%COMP%]{color:gray;font-size:20px;cursor:pointer;padding:10px}.modal-body[_ngcontent-%COMP%]{padding:0}.popup-button[_ngcontent-%COMP%]{margin:5px;height:36px}.btn-popup[_ngcontent-%COMP%]{padding-left:0;padding-right:0;margin-right:1px;margin-left:1px}.btn-primary-popup[_ngcontent-%COMP%]{width:180px}.skip-link[_ngcontent-%COMP%]{text-decoration:underline !important;border:none !important;color:#9db7b0 !important}.loader[_ngcontent-%COMP%]{width:16px;height:16px;border-radius:50%;display:block;margin:15px auto;position:relative;background:rgba(224,202,88,.6);box-shadow:-36px 0 rgba(224,202,88,.2),36px 0 #e0ca58;box-sizing:border-box;animation:shadowPulse 2s linear infinite}.step[_ngcontent-%COMP%]{display:none;opacity:0}.step.show[_ngcontent-%COMP%]{display:block;transform:scale(1);opacity:1;animation:anim 1.5s ease-in-out}@keyframes anim{0%{display:none;opacity:0}1%{display:block;opacity:0;transition:2s ease-in-out all}100%{opacity:1 !important}}@keyframes shadowPulse{33%{background:rgba(224,202,88,.4);box-shadow:-36px 0 #e0ca58,36px 0 rgba(224,202,88,.8)}66%{background:#e0ca58;box-shadow:-36px 0 rgba(224,202,88,.6),36px 0 rgba(224,202,88,.4)}100%{background:rgba(224,202,88,.6);box-shadow:-36px 0 rgba(224,202,88,.2),36px 0 #e0ca58}}.coach-scroll-arrow[_ngcontent-%COMP%]{color:var(--Text-Green-Light-Text, #9DB7B0);font-size:16px}.coach-scroll-arrow[_ngcontent-%COMP%]:hover{color:var(--Fill-Green, #44A38B)}.scroll[_ngcontent-%COMP%]{display:flex;width:40px;height:40px;padding:10px;margin:8px;justify-content:center;align-items:center;gap:10px;flex-shrink:0;border-radius:1000px;background-color:#fafaff;border:1px solid var(--Text-Green-Light-Text, #9DB7B0)}.scroll[_ngcontent-%COMP%]:hover{border:1px solid var(--Fill-Green, #44A38B)}@media(min-width: 576px){.choose-text[_ngcontent-%COMP%]{width:500px;margin-bottom:30px;font-size:1rem}.day-selection[_ngcontent-%COMP%], .time-of-day-selection[_ngcontent-%COMP%]{width:536px;margin-top:40px}.match-end[_ngcontent-%COMP%]{margin:130px auto 40px auto}.your-coach[_ngcontent-%COMP%]{margin:70px auto 5px auto}.your-coach-text[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);text-align:center;font-family:Open Sans,serif;font-size:16px;font-style:normal;font-weight:400;line-height:140%;margin-bottom:40px;height:100%;width:100%}.loader-div[_ngcontent-%COMP%]{margin:0 auto 100px auto}.light-bulb-card[_ngcontent-%COMP%]{width:700px;margin:auto}.light-bulb-image[_ngcontent-%COMP%]{min-width:60px !important;min-height:60px !important}.light-bulb-header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Poppins,serif;font-size:16px;font-style:normal;font-weight:600;line-height:130%}.light-bulb-text[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:140%}}@media(min-width: 768px){.choose-text[_ngcontent-%COMP%]{width:670px;margin-bottom:30px;font-size:1rem}.header[_ngcontent-%COMP%]{color:var(--Dark-Text, #0A4A3A);text-align:center;font-family:Poppins,serif;font-size:26px;font-style:normal;font-weight:700;line-height:140%}.text[_ngcontent-%COMP%]{color:var(--Dark-Text, #0A4A3A);text-align:center;font-family:Open Sans,serif;font-size:16px;font-style:normal;font-weight:400;line-height:140%}.button-primary[_ngcontent-%COMP%]{display:flex;width:200px;height:50px;padding:14px 4px;justify-content:center;align-items:center;gap:10px;flex-shrink:0;border-radius:60px}.button-secondary[_ngcontent-%COMP%]{display:flex;width:200px;height:50px;padding:14px 4px;justify-content:center;align-items:center;gap:10px;flex-shrink:0;border-radius:60px;border:1px solid var(--Fill-Green, #44A38B);background:var(--Fill-Background---White, #FFF)}}@media(min-width: 1200px){.container[_ngcontent-%COMP%]{margin:120px auto 40px !important;height:720px}}"] });
